import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import PublicLayout from './layouts/PublicLayout';
import Home from './pages/Home';
import Search from './pages/Search';
import Services from './pages/Services';
import Realisations from './pages/Realisations';
import ProjectDetail from './pages/ProjectDetail';
import Catalogue from './pages/Catalogue';
import CatalogueCategory from './pages/CatalogueCategory';
import Agenda from './pages/Agenda';
import ProductDetail from './pages/ProductDetail';
import QuiSommesNous from './pages/QuiSommesNous';
import Contact from './pages/Contact';
import Account from './pages/account/Account';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import ProtectedRoute from './routes/ProtectedRoute';
import AdminLayout from './layouts/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import CommercialWelcome from './pages/admin/CommercialWelcome';
import AdminIndex from './pages/admin/AdminIndex';
import AdminCategories from './pages/admin/Categories';
import AdminProducts from './pages/admin/Products';
import AdminProjects from './pages/admin/Projects';
import AdminEvents from './pages/admin/Events';
import AdminTeam from './pages/admin/Team';
import AdminSettings from './pages/admin/Settings';
import AdminServices from './pages/admin/Services';
import AdminMessages from './pages/admin/Messages';
import AdminSuppliers from './pages/admin/Suppliers';
import AdminReferences from './pages/admin/References';
import AdminHomeSlides from './pages/admin/HomeSlides';
import AdminPlanning from './pages/admin/Planning';
import AdminChantiers from './pages/admin/Chantiers';
import WorkerLayout from './layouts/WorkerLayout';

import AdminUsers from './pages/admin/Users';

import { DataProvider } from './context/DataContext';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <DataProvider>
        <ScrollToTop />
        <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/realisations/:slug" element={<ProjectDetail />} />
          <Route path="/catalogue" element={<Catalogue />} />
          <Route path="/catalogue/:parentSlug/:slug" element={<CatalogueCategory />} />
          <Route path="/catalogue/:slug" element={<CatalogueCategory />} />
          <Route path="/catalogue/:parentSlug/:slug/:productSlug" element={<ProductDetail />} />
          <Route path="/catalogue/:slug/:productSlug" element={<ProductDetail />} />
          <Route path="/produits/:slug" element={<ProductDetail />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/search" element={<Search />} />
          <Route path="/account" element={<Account />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["admin", "commercial"]} />}>
          <Route path="/admin" element={<AdminLayout />}>
            {/* Index route decides by role to avoid redirect conflicts */}
            <Route index element={<AdminIndex />} />
            {/* Admin-only subset */}
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="team" element={<AdminTeam />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="suppliers" element={<AdminSuppliers />} />
              <Route path="references" element={<AdminReferences />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
            {/* Shared access (admin + commercial) */}
            <Route path="categories" element={<AdminCategories />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="events" element={<AdminEvents />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="slides" element={<AdminHomeSlides />} />
            <Route path="planning" element={<AdminPlanning />} />
            <Route path="chantiers" element={<AdminChantiers />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['worker', 'admin', 'commercial']} />}>
          <Route path="/mon-planning" element={<WorkerLayout />} />
        </Route>
      </Routes>
    </DataProvider>
  </BrowserRouter>
);
}

export default App;
